import { TooltipContainer } from "@outplayed/tooltips";
import React from "react";
import { EXPANSION, getFormattedContentType, getFormattedNames, SEASON } from "../../../lib/wowHelpers";
import Icon from "../../Common/Icon";
import CopyTalentsButton from "../../Common/CopyTalentsButton";
import { ReactComponent as TooltipIcon } from "svg/question-line-white.svg";
import { Link, useLocation } from "react-router-dom";

const TalentTreeHeader = (props) => {
  const {
    showViewMore,
    classType,
    popularity,
    mainStat,
    statLabel,
    statTooltip,
    encounterType,
    selectedTalents,
    specType,
    allTrees,
  } = props;
  const { displayClassName, displaySpecName, dataClassName, dataSpecName } = getFormattedNames(classType, specType);
  const { search } = useLocation();

  return (
    <div className="talent-tree-header-container">
      <div className="title-and-description">
        <div className="title">
          <Icon
            iconSize={"24px"}
            staticDataImg={`https://static.bigbrain.gg/wow/spec-icons/${dataClassName}-${dataSpecName}.jpg`}
          />
          <div>
            The Best {displaySpecName} {displayClassName} Talents {encounterType === "PvP" ? "for PvP" : "Build"}
          </div>
        </div>
        <div className="description">
          Use these {displaySpecName} {displayClassName} Talents for all your {getFormattedContentType(encounterType)} needs in{" "}
          {EXPANSION} Season {SEASON}.
        </div>
      </div>
      <div className="stats-and-buttons-container">
        <div className="box-container stats">
          <div className="stat-value">{mainStat}</div>
          <div className="stat-label">
            {statLabel}
            <TooltipContainer tooltipInfo={statTooltip}>
              <div>
                <TooltipIcon className="tooltip-icon" />
              </div>
            </TooltipContainer>
          </div>
        </div>
        <div className="box-container stats">
          <div className="stat-value">{popularity}</div>
          <div className="stat-label">
            Talent Popularity
            <TooltipContainer
              tooltipInfo={`Talent Popularity is how often this particular talent build was used by a spec in the top rankings of the ${
                encounterType === "PvP" ? "PvP leaderboards" : "Raid and Mythic+ Dungeons"
              } displayed as a percent of the total popularity of all analyzed talent builds.`}
            >
              <div>
                <TooltipIcon className="tooltip-icon" />
              </div>
            </TooltipContainer>
          </div>
        </div>
        <div className="box-container buttons">
          <CopyTalentsButton label="Copy" />
          {showViewMore ? (
            <div className="view-more-container">
              <Link
                to={{
                  pathname: `/wow/${props.specType}/${props.classType}/builds${props.encounterType === "raid" ? "/raid" : ""}`,
                  search: search,
                }}
              >
                <button className="view-more-button">View More</button>
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TalentTreeHeader;
